import { Stack, Typography } from "@mui/material";

// The card's bottom slot is one of four (Pay / Close / Closed / Unavailable) and they must be the
// same box: the line-height matches the Typography of the pills rather than MUI Button's taller
// default. Shared by the pills here and the buttons in MultiPayerPaymentRequestAction.
export const MULTI_PAYER_ACTION_SX = {
  mx: 1,
  mb: 1,
  width: "calc(100% - 16px)",
  py: 1.5,
  borderRadius: 3,
  fontSize: 18,
  fontWeight: 600,
  lineHeight: 1.5,
  textTransform: "none",
} as const;

type Props = {
  label: string;
  backgroundColor: string;
  /** A sentence (e.g. why the viewer cannot pay) wraps, so it reads at body size, not button size. */
  fontSize?: number;
};

/** A non-interactive state label in the card's action slot (Closed, Unavailable, Lite-restricted). */
export const MultiPayerPaymentRequestPill = ({
  label,
  backgroundColor,
  fontSize = MULTI_PAYER_ACTION_SX.fontSize,
}: Props) => (
  <Stack
    direction="row"
    alignItems="center"
    justifyContent="center"
    sx={{
      ...MULTI_PAYER_ACTION_SX,
      // Matches the outlined Close button's 1px border so all slots are the same height.
      border: "1px solid transparent",
      backgroundColor,
    }}
  >
    <Typography
      fontWeight={600}
      fontSize={fontSize}
      color="common.white"
      textAlign="center"
    >
      {label}
    </Typography>
  </Stack>
);
